import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";

export const DouyinGetTopicsParamsSchema = ActionCommonParamsSchema.extend({
    keyword: z.string().optional(),
    count: z.number().optional(),
});

export type DouyinGetTopicsParams = z.infer<typeof DouyinGetTopicsParamsSchema>;
